
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateTimeBlockTemplateEntryDtoFormGroup() {
return new FormGroup({
    timeBlockTemplateId: new FormControl<number | undefined>(undefined, [Validators.required]),
    timeStart: new FormControl<string | undefined>('', [Validators.required]),
    timeEnd: new FormControl<string | undefined>('', [Validators.required]),
    timerecordtypeId: new FormControl<number | undefined>(undefined, [Validators.required]),
    label: new FormControl<string | undefined>(undefined, [Validators.maxLength(50)]),
    sortOrder: new FormControl<number | undefined>(undefined),
    autoCreate: new FormControl<boolean | undefined>(false),
})
;
}
      